var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _g, _g2, _path3, _path4, _path5, _g3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgfilter5Advanced = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M32.25 119.8c.248 0 .451.222.451.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M32.25 116c.248 0 .451.221.451.493v2.172c0 .272-.203.493-.452.493s-.452-.221-.452-.493v-2.172c0-.272.203-.493.452-.493M29.452 118.986h1.788c.25 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M33.258 118.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M252.249 23.8c.249 0 .452.222.452.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M252.249 20c.249 0 .452.221.452.493v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.493.452-.493M249.452 22.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M253.258 22.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M22 28.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#99CCBF",
  d: "M91.082 109.014a.67.67 0 0 1 .121.745l-.703 1.591a5.7 5.7 0 0 1 .61 1.38l1.65.549a.67.67 0 0 1 .47.592q.034.563-.018 1.121l-.03.277a7.6 7.6 0 0 1-.226 1.113.67.67 0 0 1-.584.479l-1.727.189a5.7 5.7 0 0 1-.89 1.219l.346 1.701a.67.67 0 0 1-.28.702 7.6 7.6 0 0 1-1.114.606 7.6 7.6 0 0 1-1.197.416.67.67 0 0 1-.709-.264l-1.026-1.401a5.7 5.7 0 0 1-1.5-.161l-1.298 1.152a.68.68 0 0 1-.748.11 7.5 7.5 0 0 1-.975-.582l-.225-.163a7.4 7.4 0 0 1-.842-.742.67.67 0 0 1-.121-.745l.703-1.591a5.8 5.8 0 0 1-.611-1.382l-1.65-.55a.67.67 0 0 1-.47-.591 7.4 7.4 0 0 1 .017-1.121l.03-.277q.072-.567.227-1.113a.67.67 0 0 1 .584-.479l1.726-.189c.24-.441.54-.853.891-1.219l-.346-1.701a.67.67 0 0 1 .28-.702 7.572 7.572 0 0 1 2.31-1.025.67.67 0 0 1 .708.265l1.026 1.4a5.7 5.7 0 0 1 1.501.161l1.301-1.15a.68.68 0 0 1 .748-.11q.507.252.976.581l.225.164q.447.337.841.741zm-4.486 7.486a2.38 2.38 0 0 0 1.214-3.135 2.376 2.376 0 0 0-4.392.106 2.375 2.375 0 0 0 3.178 3.029M91.405 92.433c.145.15.177.373.092.564l-.532 1.203a4.3 4.3 0 0 1 .462 1.043l1.247.416c.199.064.342.239.356.447q.025.426-.014.848l-.023.209a6 6 0 0 1-.17.842.51.51 0 0 1-.442.362l-1.306.143a4.3 4.3 0 0 1-.673.922l.261 1.286a.51.51 0 0 1-.212.531 5.7 5.7 0 0 1-.842.458 6 6 0 0 1-.905.315.51.51 0 0 1-.536-.2l-.776-1.059a4.3 4.3 0 0 1-1.135-.122l-.98.871a.51.51 0 0 1-.566.083 6 6 0 0 1-.738-.44l-.17-.123a6 6 0 0 1-.636-.561.51.51 0 0 1-.092-.564l.532-1.203a4.4 4.4 0 0 1-.463-1.045l-1.248-.416a.51.51 0 0 1-.355-.447 5.6 5.6 0 0 1 .013-.848l.023-.209q.055-.43.171-.842a.51.51 0 0 1 .442-.362l1.306-.143c.181-.333.407-.644.673-.922l-.262-1.286a.51.51 0 0 1 .213-.531q.392-.263.84-.46.448-.198.906-.315a.51.51 0 0 1 .536.2l.775 1.06c.384-.01.766.031 1.135.12l.985-.87a.51.51 0 0 1 .565-.082q.384.19.738.44l.17.123q.338.255.636.561zm-3.392 5.66a1.8 1.8 0 0 0 .918-2.37 1.796 1.796 0 0 0-3.321.08 1.796 1.796 0 0 0 2.403 2.29M117.558 98.767c.37.382.453.953.235 1.438l-1.358 3.071q.376.616.678 1.293.298.678.5 1.371l3.186 1.061c.506.165.873.611.906 1.141.046.727.032 1.447-.033 2.166l-.059.534q-.138 1.096-.436 2.149c-.142.514-.601.868-1.128.925l-3.333.365a11 11 0 0 1-1.72 2.353l.669 3.284c.106.524-.095 1.064-.543 1.356-.67.441-1.388.834-2.149 1.17-.761.337-1.534.604-2.311.803-.518.135-1.052-.08-1.368-.511l-1.98-2.704a11 11 0 0 1-2.898-.31l-2.505 2.224a1.31 1.31 0 0 1-1.444.212q-.979-.489-1.883-1.123l-.435-.316a14 14 0 0 1-1.624-1.432 1.3 1.3 0 0 1-.235-1.438l1.358-3.071a11 11 0 0 1-.68-1.298c-.2-.451-.366-.911-.5-1.371l-3.187-1.061a1.3 1.3 0 0 1-.906-1.142 14 14 0 0 1 .034-2.165l.058-.534c.091-.73.239-1.447.436-2.149.143-.515.601-.868 1.128-.925l3.334-.365a11 11 0 0 1 1.72-2.353l-.67-3.285c-.105-.523.095-1.063.543-1.356a14 14 0 0 1 2.147-1.175 15 15 0 0 1 2.311-.803c.518-.135 1.052.08 1.368.511l1.981 2.704c.979-.026 1.956.082 2.898.31l2.512-2.22c.397-.352.969-.448 1.443-.213q.98.489 1.884 1.123l.434.316q.864.65 1.625 1.432zm-8.659 14.451a4.59 4.59 0 0 0 2.342-6.052 4.586 4.586 0 0 0-6.054-2.338 4.587 4.587 0 1 0 3.712 8.39"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 78.471,
  height: 46,
  x: 147,
  y: 20,
  fill: "#008060",
  rx: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 156.05,
  y: 28.156,
  fill: "#fff",
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 156.05,
  y: 44.102,
  fill: "#66B3A0",
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 17.066,
  height: 12.756,
  x: 177.382,
  y: 28.156,
  fill: "#66B3A0",
  rx: 1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 17.066,
  height: 12.756,
  x: 177.382,
  y: 44.102,
  fill: "#66B3A0",
  rx: 1
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 197.292,
  y: 28.156,
  fill: "#66B3A0",
  rx: 1
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 197.292,
  y: 44.102,
  fill: "#66B3A0",
  rx: 1
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 93,
  height: 52,
  x: 128,
  y: 72,
  fill: "#fff",
  rx: 2
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 32.222,
  height: 6.444,
  x: 134.444,
  y: 76.832,
  fill: "#008060",
  rx: 3.222
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 5,
  x: 134,
  y: 88,
  fill: "#E1E1E1",
  opacity: 0.4,
  rx: 2.5
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 5,
  x: 134,
  y: 96,
  fill: "#E1E1E1",
  opacity: 0.4,
  rx: 2.5
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 5,
  x: 134,
  y: 104,
  fill: "#E1E1E1",
  opacity: 0.4,
  rx: 2.5
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 41,
  height: 5,
  x: 134,
  y: 112,
  fill: "#E1E1E1",
  opacity: 0.4,
  rx: 2.5
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 70.429,
  height: 34,
  x: 71,
  y: 23,
  fill: "#fff",
  rx: 2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#E1E1E1",
  clipPath: "url(#img_filter5_advanced_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 83.5,
  cy: 33.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95.129,
  cy: 33.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106.758,
  cy: 33.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118.387,
  cy: 33.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130.016,
  cy: 33.934,
  r: 4,
  opacity: 0.8
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#E1E1E1",
  clipPath: "url(#img_filter5_advanced_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 83.5,
  cy: 46.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95.129,
  cy: 46.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106.758,
  cy: 46.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118.387,
  cy: 46.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130.016,
  cy: 46.895,
  r: 4
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M28 66a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v17.976a2 2 0 0 1-2 2H30a2 2 0 0 1-2-2z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4.503,
  d: "M63 75h49"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4.503,
  d: "M39.566 74.684h24.506",
  opacity: 0.4
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#img_filter5_advanced_svg__c)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 64.072,
  cy: 74.684,
  r: 4.901,
  fill: "#66B3A0"
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 64.073,
  cy: 74.684,
  r: 3.676,
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter5_advanced_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M79.5 29.072h54.516v9.721H79.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter5_advanced_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M79.5 42.033h54.516v9.721H79.5z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "img_filter5_advanced_svg__c",
  width: 15.207,
  height: 15.207,
  x: 57.37,
  y: 67.982,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.901,
  dy: 0.901
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.351
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.501961 0 0 0 0 0.376471 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10238_4867"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_10238_4867",
  result: "shape"
})))));
export { SvgImgfilter5Advanced as ReactComponent };
export default __webpack_public_path__ + "static/media/img.filter5.advanced.7bbcdea9.svg";